//
//
//
//
//
//
//
//
//

import i18n from "@/utils/i18n";
import { deepClone } from "@/utils/util";
export default {
  name: "customClass-editor",
  componentName: 'PropertyEditor',
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  data: function data() {
    return {
      cssClassList: []
    };
  },
  created: function created() {
    var _this = this;
    this.cssClassList = deepClone(this.designer.getCssClassList());
    //监听表单css代码改动事件并重新加载！
    this.designer.handleEvent('form-css-updated', function (cssClassList) {
      _this.cssClassList = cssClassList;
    });
  }
};